import { render, staticRenderFns } from "./seckillModal.vue?vue&type=template&id=c8e2d5da&scoped=true&"
import script from "./seckillModal.ts?vue&type=script&lang=ts&"
export * from "./seckillModal.ts?vue&type=script&lang=ts&"
import style0 from "./seckillModal.vue?vue&type=style&index=0&id=c8e2d5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e2d5da",
  null
  
)

export default component.exports